(function(){


function initProductAnchorNav(){


const links =
document.querySelectorAll(
".anchor-link"
);



if(!links.length){

return;

}




const nav =
document.querySelector(
".product-anchor-nav"
);



if(!nav){

return;

}




/*
 当前激活
*/

function setActive(link){


if(!link){

return;

}


links.forEach(function(item){

item.classList.remove(
"active"
);

});


link.classList.add(
"active"
);




/*
 手机标题居中
*/

if(window.innerWidth <= 768){


link.scrollIntoView({

behavior:"smooth",

block:"nearest",

inline:"center"

});


}


}







/*
 点击锚点
*/

links.forEach(function(link){


if(link.dataset.binded){

return;

}


link.dataset.binded="true";



link.addEventListener(

"click",

function(){


const targetId =
this.dataset.target;



const target =
document.getElementById(
targetId
);



if(!target){

return;

}



setActive(this);



target.scrollIntoView({

behavior:"smooth",

block:"start"

});


});


});








/*
 判断滚动模式
*/

const isMobile =
window.innerWidth <= 768;



const scrollContainer =
document.querySelector(
".page-wrapper"
);






function getScrollTop(){



if(isMobile){


return (

window.scrollY ||

document.documentElement.scrollTop ||

document.body.scrollTop ||

0

);


}else{


return scrollContainer
?
scrollContainer.scrollTop
:
0;


}



}








function handleScroll(){


const scrollTop =
getScrollTop();



console.log(
"Anchor Scroll:",
scrollTop,
"Mobile:",
isMobile
);





/*
 顶部隐藏
*/

if(scrollTop < 100){


nav.classList.remove(
"show"
);


return;

}





nav.classList.add(
"show"
);







/*
 当前模块判断
*/

let current=null;



links.forEach(function(link){



const target =
document.getElementById(
link.dataset.target
);



if(!target){

return;

}



const rect =
target.getBoundingClientRect();




if(

rect.top <= 160 &&

rect.bottom > 160

){


current=link;


}



});





if(

current &&

!current.classList.contains("active")

){


setActive(current);


}


}







/*
 注册滚动监听
*/


if(isMobile){


window.addEventListener(

"scroll",

handleScroll,

{

passive:true

}

);



}else{


if(scrollContainer){


scrollContainer.addEventListener(

"scroll",

handleScroll,

{

passive:true

}

);


}


}






/*
 初始化
*/

handleScroll();



}






/*
 Shopify加载
*/

if(
document.readyState==="loading"
){


document.addEventListener(

"DOMContentLoaded",

initProductAnchorNav

);


}else{


initProductAnchorNav();


}




document.addEventListener(

"shopify:section:load",

function(){

initProductAnchorNav();

}

);



})();